import { SITE } from "@/lib/site";

const REGIONS = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "SK", name: "Saskatchewan" },
  { code: "MB", name: "Manitoba" },
  { code: "ON", name: "Ontario" },
  { code: "US", name: "Cross-Border USA" },
];

export const Coverage = () => {
  return (
    <section
      id="coverage"
      data-testid="coverage-section"
      className="relative bg-[#0A0A0A] py-24 lg:py-32 border-t border-[#161616] overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={SITE.assets.mapBg}
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-black/70 to-[#0A0A0A]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-3 mb-5">
            <span className="h-[2px] w-10 bg-[#1E5BFF]" />
            <span className="font-display text-xs font-bold uppercase tracking-[0.3em] text-[#1E5BFF]">
              Coverage Area
            </span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase text-white tracking-tighter leading-[0.95]">
            Western Canada.
            <br />
            <span className="text-[#1E5BFF]">Cross-Border Ready.</span>
          </h2>
          <p className="mt-6 text-slate-300 text-base md:text-lg leading-relaxed">
            Based in Alberta and dispatching across Western Canada, with regular runs into the
            United States. If it has to get there — and it has to get there <em>now</em> — Coreline
            is your call.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-px bg-[#1a1a1a]">
          {REGIONS.map((r) => (
            <div
              key={r.code}
              data-testid={`coverage-region-${r.code.toLowerCase()}`}
              className="card-industrial p-6 lg:p-8 text-center"
            >
              <div className="font-display text-3xl lg:text-4xl font-black text-[#1E5BFF] tracking-tighter">
                {r.code}
              </div>
              <div className="mt-2 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-white/80">
                {r.name}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-slate-400 text-sm">
          <span className="font-display font-bold uppercase tracking-[0.2em] text-white">
            Service Area:
          </span>{" "}
          {SITE.contact.serviceArea}
        </div>
      </div>
    </section>
  );
};
